import WideSlider from "../components/WideSlider/WideSlider";

function TestPage() {
    return (
        <WideSlider/>
    );
  }
  
  export default TestPage;
  